import {
  Card,
  Container,
  Stack,
  Typography,
  Button,
  Backdrop,
  CircularProgress,
  Chip,
  Alert
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Link as RouterLink, useParams } from 'react-router-dom';
import { fDateTime } from '../utils/formatTime';
import api from '../utils/api';
import { TipResult } from '../utils/constants';
import Page from '../components/Page';

function TipDetails() {
  const { id: tipId } = useParams();

  const [tip, setTip] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetch = async () => {
    setLoading(true);
    try {
      const response = await api.get(`/tips/getTipAdmin`, { id: tipId });
      setTip(response.tip);
    } catch (e) {
      console.log(e.toString());
      setErrorMessage(e.toString());
    }
    setLoading(false);
  };

  const markResult = async (result) => {
    setLoading(true);
    try {
      const response = await api.post(`/tips/markResult`, { id: tipId, result });
      setTip(response.tip);
    } catch (e) {
      console.log(e.toString());
      setErrorMessage(e.toString());
    }
    setLoading(false);
  };

  return (
    <Page title="Team">
      <Backdrop style={{ zIndex: 100, color: '#fff' }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      {errorMessage && errorMessage.length > 0 && <Alert variant="error">{errorMessage}</Alert>}
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Tip Details
          </Typography>
        </Stack>
        <Card>
          {tip && (
            <Stack spacing={1} padding={2}>
              <Typography variant="h4">{tip.title}</Typography>
              <Typography>{tip.description}</Typography>
              <Stack direction="row" spacing={1} alignItems="center">
                <Typography>{tip.inApp.price}</Typography>
                <Button size="small" variant="contained">
                  View {tip.purchases.length} Purchases
                </Button>
              </Stack>
              <Stack>
                <Typography variant="caption">{tip.createdBy.username}</Typography>
                <Typography variant="caption">
                  {tip.createdBy.name}({tip.createdBy.email})
                </Typography>
              </Stack>
              <Typography>
                {tip.event.homeTeam.name} vs {tip.event.awayTeam.name}
              </Typography>
              <Typography variant="caption">{fDateTime(tip.event.commenceDate)}</Typography>
              <Stack width="100px">
                {tip.isResolved ? (
                  <Chip label="Resolved" color="success" />
                ) : (
                  <Chip label="Unresolved" color="error" />
                )}
              </Stack>
              <Stack direction="row" spacing={1}>
                <Button variant="contained" onClick={() => markResult(TipResult.success)}>
                  Mark Success
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  onClick={() => markResult(TipResult.failure)}
                >
                  Mark Failure
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  onClick={() => markResult(TipResult.push)}
                >
                  Mark Push
                </Button>
              </Stack>
            </Stack>
          )}
        </Card>
      </Container>
    </Page>
  );
}

export default TipDetails;
